import React from 'react'

const CalendarIcon = () => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M6.66634 1.66667H4.99967V3.33366H4.16602C3.2458 3.33384 2.50018 4.07946 2.5 4.99968V16.6667C2.5 17.587 3.24569 18.3335 4.16602 18.3337H15.833C16.7535 18.3337 17.5 17.5871 17.5 16.6667V4.99968C17.4998 4.07936 16.7534 3.33366 15.833 3.33366H14.9997V1.66667H13.333V3.33366H6.66634V1.66667ZM4.16602 6.66667V4.99968H15.833V6.66667H4.16602ZM4.16602 8.33334V16.6667H15.833V8.33334H4.16602Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export default CalendarIcon
